// export const API_URL = 'http://10.33.57.51/';
// export const API_URL_VPN = 'http://10.33.58.34/';

export const API_URL = 'https://lakarti-photo.ru/';
// export const API_URL = 'http://localhost:8000/';
// export const API_URL_VPN = 'http://212.60.20.182/';
// export const API_URL = 'http://lakarti.forkdom.by:8000/';
